import * as React from 'react'
import { Redirect, RouteProps } from 'react-router'
import { isTokenValid } from '../../utils/auth'
import RouteWithMenu from '../../containers/navigation/RouteWithMenu'

class AuthRouteWithMenu extends React.Component<RouteProps> {
  public render() {
    if (!isTokenValid()) {
      return <Redirect to='/auth' />
    }

    return <RouteWithMenu {...this.props} />
  }
}

export default AuthRouteWithMenu



// WEBPACK FOOTER //
// ./src/components/navigation/AuthRouteWithMenu.tsx